<template lang="pug">
table.text-white(style="width:100%")
  tr
    th ID
    th CASH
    th BET 
    th WIN 
    th BETINFO
    th MATRIX
    th WINLINES
  tr
    td(v-if="ID!== ''")  {{ID}}
    td(v-else)
      i.fas.fa-sync.fa-spin
    td(v-if="before!== ''")  {{before}}
    td(v-else)
      i.fas.fa-sync.fa-spin
    td(v-if="bet!== ''")  {{bet}}
    td(v-else)
      i.fas.fa-sync.fa-spin
    td(v-if="win!== ''")  {{win}}
    td(v-else)
      i.fas.fa-sync.fa-spin
    td(v-if="BetInfo!== ''")  {{BetInfo}}
    td(v-else)
      i.fas.fa-sync.fa-spin
    td 
      .matrix-display
    td(v-if="winLines!== ''")  {{winLines}}
    td(v-else)
      i.fas.fa-sync.fa-spin
</template>
<script>
import * as matrixPlugin from '../../assets/js/matrix.js'
import _ from "lodash";
export default {
  // props:{
  //   resultData: {
  //     type: Array,
  //     default: () => []
  //   },
  // },
  data(){
    return{
      // sample: [
			//   {
			//     "id": "552977853",
			//     "status": "1",
			//     "BetInfo": "{\"chipSize\":300,\"numChips\":\"1\",\"lines\":20,\"bet\":3}",
			//     "gameId": "6937",
			//     "gameName": "Age Of Conquest",
			//     "cdn": "https://cdn.cdnpin.com/resources/thumbnails/microgaming/ageOfConquest",
			//     "before": "237.29",
			//     "bet": "60.00",
			//     "win": "0.00",
			//     "dateTime": "2023-02-27 04:36:16",
			//     "matrix": {
			//       "matrix": [
			//         [
			//           10,
			//           5,
			//           2,
			//           8,
			//           5
			//         ],
			//         [
			//           4,
			//           6,
			//           2,
			//           9,
			//           9
			//         ],
			//         [
			//           11,
			//           8,
			//           7,
			//           7,
			//           11
			//         ]
			//       ],
			//       "imgSize": 40,
			//       "imgUrl": "https://cdn.cdnpin.com/resources/thumbnails//microgaming/ageOfConquest/",
			//       "class": "slot",
			//       "string": "<br>Z4_139552456_4"
			//     },
			//     "winLines": "[]",
			//     "actionId": "Z4_139552456_4"
			//   },
	    // ],
      ticketId : "",
      target:"",
      resultData: [],
      ID: "",
      before: "",
      bet: "",
      win: "",
      BetInfo: "",
      winLines: ""
    }
  },
  computed:{
    betDetail(){
      return this.$store.getters.sbResult.data;
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    accountID() {
      return this.$store.getters.accountID
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  created(){
    if(!_.isEmpty(this.$route.query)){
      var temp = this.$route.query.action.split("&")
      this.ticketId = temp[0]
      this.target = temp[1]
    }
  },
  mounted(){
    this.getBetDetail()
  },
  methods:{
    getBetDetail(){
      if(this.resultData.length > 0){
        this.resultData = [];
      }
      let player_id = this.accountID
      let ticket_id = this.ticketId
      let lang_code = this.getLanguage
      this.$store
        .dispatch("user/getNekoResult", { player_id, ticket_id, lang_code })
        .then(response => {
          if (response.success == true) {
            var betDetails = response.data.content.log
            betDetails.filter(x => x.actionId == this.target).forEach(y => {
              this.resultData.push(y)
            })
            this.ID = this.resultData[0].id
            this.before = this.resultData[0].before
            this.bet = this.resultData[0].bet
            this.win = this.resultData[0].win
            this.BetInfo = this.resultData[0].BetInfo
            this.winLines = this.resultData[0].winLines
            var elem = $(".matrix-display")
            // console.log(typeof this.resultData[0])
            matrixPlugin.matrixDrawExport(elem, this.resultData[0].matrix)
          } else {             
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {console.log(response)
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        }); 
    }
  }
}
</script>
<style lang="scss" scoped>
.col{
  word-wrap: break-word;
}
table, th, td {
  border: 1px solid white;
}
</style>